import { render, staticRenderFns } from "./SalesOrderForm.vue?vue&type=template&id=88d86568&scoped=true&"
import script from "./SalesOrderForm.vue?vue&type=script&lang=js&"
export * from "./SalesOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderForm.vue?vue&type=style&index=0&id=88d86568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d86568",
  null
  
)

export default component.exports